<script>
const { VUE_APP_API_HOST } = process.env

export default {
  methods: {
    getVariables() {
      return this.$http.get(`${VUE_APP_API_HOST}/custom-variables`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      .then(
        (res) => res.body || { variables: [], values: [] },
        (err) => err
      )
    },

    newVariable(name) {
      return this.$http
        .post(`${VUE_APP_API_HOST}/custom-variables`, { name }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    updateVariable(variable) {
      return this.$http
        .put(`${VUE_APP_API_HOST}/custom-variables/${variable.id}`, variable, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    deleteVariable(id) {
      return this.$http
        .delete(`${VUE_APP_API_HOST}/custom-variables/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    },

    saveVariableValue(variableId, page, value) {
      return this.$http
        .put(`${VUE_APP_API_HOST}/custom-variables/${variableId}/values`, { page, value }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(
          (res) => res,
          (err) => err
        )
    }
  }
}
</script>
